const translations = {
  en: {
    nav: {
      home: "Home", menu: "Menu", about: "About Us",
      catering: "Catering", reviews: "Reviews", contact: "Contact",
      orderOnline: "Order Online",
    },
    hero: {
      badge: "Montreal's Caribbean Gem",
      headline: "Authentic Caribbean\nFlavors in Montreal",
      subheadline: "Fresh ingredients, bold island flavors, and unforgettable meals made with love.",
      ctaOrder: "Order Online",
      ctaMenu: "View Menu",
      ctaCall: "Call Now",
    },
    popularDishes: {
      overline: "Signature Dishes",
      title: "Taste the Caribbean\nin Every Bite",
      subtitle: "Handcrafted with authentic recipes passed down through generations.",
      viewMenu: "View Full Menu",
      dishes: [
        { name: "Griot", description: "Crispy Haitian marinated pork, slow-braised with citrus and spices, fried to golden perfection.", tag: "Fan Favourite" },
        { name: "Jerk Chicken", description: "Tender chicken with bold Jamaican jerk seasoning, grilled and served with island sides.", tag: "Best Seller" },
        { name: "Rice & Beans", description: "Fragrant rice simmered with coconut milk, kidney beans, and authentic Creole spices.", tag: "" },
        { name: "Plantains", description: "Sweet golden fried plantains, caramelized to perfection — the ultimate Caribbean side.", tag: "" },
        { name: "Patties", description: "Flaky golden-baked pastry filled with well-seasoned spiced meat, Caribbean street food style.", tag: "Street Food" },
        { name: "Caribbean Combos", description: "Generous portions of multiple signature dishes in one satisfying, flavorful meal.", tag: "Great Value" },
      ],
    },
    whyUs: {
      overline: "Why Choose Us",
      title: "More Than Just\na Restaurant",
      subtitle: "We bring the warmth and soul of the Caribbean to every plate we serve.",
      features: [
        { icon: "ChefHat", title: "Authentic Recipes", desc: "Traditional Antillean and Caribbean recipes passed down through generations of family cooking." },
        { icon: "Leaf", title: "Fresh Ingredients", desc: "We source the freshest, highest quality ingredients to deliver maximum island flavors." },
        { icon: "Heart", title: "Made with Love", desc: "Each meal is prepared with care, passion, and the warmth of Caribbean hospitality." },
        { icon: "Users", title: "Trusted by Locals", desc: "A beloved fixture in Montreal's Caribbean food scene, trusted by thousands of happy customers." },
        { icon: "Utensils", title: "Family & Catering", desc: "Perfect for family meals, parties, office catering, and all your special events." },
      ],
    },
    about: {
      overline: "Our Story",
      title: "A Taste of Home,\nRight Here in Montreal",
      p1: "Chala Le Gouter Antillais was born from a deep love of Caribbean culture and the authentic flavors of the Antilles. Our kitchen tells stories — of spice markets, family kitchens, and the vibrant spirit of the islands.",
      p2: "We bring to Montreal the bold, soulful flavors of Haitian and Antillean cooking, using traditional family recipes and the freshest ingredients. Every meal is a celebration of where we come from.",
      cta: "Read Our Full Story",
      stats: [
        { value: "10+", label: "Years Serving Montreal" },
        { value: "500+", label: "Happy Customers Weekly" },
        { value: "100%", label: "Authentic Recipes" },
      ],
    },
    reviews: {
      overline: "Customer Reviews",
      title: "What Montreal\nis Saying",
      subtitle: "Join thousands of satisfied customers who love our authentic Caribbean cuisine.",
      testimonials: [
        { name: "Marie-Claire Fontaine", location: "Montréal-Nord", rating: 5, text: "The best griot I've had outside of Haiti! The flavors are absolutely authentic and the service is always warm and welcoming. This is my go-to spot for Caribbean food in Montreal." },
        { name: "David Thompson", location: "Plateau-Mont-Royal", rating: 5, text: "Incredible jerk chicken! I've tried many Caribbean restaurants in Montreal but nothing compares to Chala. The combination platter is outstanding value." },
        { name: "Isabelle Laurent", location: "Rivière-des-Prairies", rating: 5, text: "We ordered catering for our office party and everyone was blown away. Professional service, generous portions, and truly authentic Caribbean flavors. 10/10!" },
        { name: "Jean-Paul Moreau", location: "Saint-Léonard", rating: 5, text: "The plantains and rice & beans are out of this world! A hidden gem in Montreal. Our whole family loves coming here for Sunday meals." },
        { name: "Sophie Beauchamp", location: "Laval", rating: 5, text: "From the very first bite, I was transported to the Caribbean. The food is fresh, flavorful, and made with obvious love. Highly recommend the combo plate!" },
        { name: "Antoine Delacroix", location: "Anjou", rating: 5, text: "Best Caribbean patties in the city! My colleagues and I order from here every Friday. Always fresh, always delicious, always on time." },
      ],
    },
    catering: {
      overline: "Catering & Events",
      title: "We Bring the\nCaribbean to You",
      subtitle: "From intimate family gatherings to large corporate events, we make every occasion unforgettable with authentic Caribbean cuisine.",
      events: [
        { icon: "PartyPopper", title: "Birthday Parties", desc: "Make your birthday unforgettable with a Caribbean feast for family and friends." },
        { icon: "Building2", title: "Corporate Events", desc: "Impress your team and clients with a unique Caribbean catering experience." },
        { icon: "Heart", title: "Private Gatherings", desc: "Intimate dinners, anniversaries, graduations — we cater to every special moment." },
        { icon: "Users", title: "Family Reunions", desc: "Bring the family together with our generous Caribbean platters that serve everyone." },
      ],
      cta: "Request a Catering Quote",
      ctaSecondary: "Call to Discuss",
      features: ["Customizable menus", "On-site or delivery", "Any group size", "Professional service"],
    },
    contact: {
      overline: "Find Us",
      title: "Visit Us Today",
      subtitle: "We'd love to see you. Come experience the Caribbean in the heart of Montreal.",
      address: "11866 Bd Rivière-des-Prairies\nMontréal, QC H1C 1P9",
      phone: "(514) 588-3708",
      hoursTitle: "Business Hours",
      hours: [
        { day: "Monday", hours: "11:00 AM – 7:00 PM" },
        { day: "Tuesday", hours: "11:00 AM – 8:00 PM" },
        { day: "Wednesday", hours: "11:00 AM – 9:00 PM" },
        { day: "Thursday", hours: "11:00 AM – 9:00 PM" },
        { day: "Friday", hours: "11:00 AM – 9:00 PM" },
        { day: "Saturday", hours: "11:00 AM – 8:00 PM" },
        { day: "Sunday", hours: "12:00 PM – 7:00 PM" },
      ],
      form: {
        title: "Send Us a Message",
        name: "Full Name", email: "Email Address", phone: "Phone Number (Optional)",
        subject: "Subject", message: "Your Message", send: "Send Message",
        success: "Message sent! We'll get back to you soon.",
        error: "Failed to send. Please call us directly.",
      },
    },
    footer: {
      tagline: "Authentic Caribbean flavors in the heart of Montreal.",
      quickLinks: "Quick Links", contactUs: "Contact Us", hours: "Hours",
      copyright: "© 2025 Chala Le Gouter Antillais. All rights reserved.",
    },
    menu: {
      title: "Our Menu",
      subtitle: "Explore our full selection of authentic Caribbean dishes",
      allItems: "All Items",
      spicy: "Spicy",
    },
    aboutPage: {
      hero: { overline: "Our Story", title: "Born from a Love of Caribbean Culture" },
      story: {
        title: "From the Islands\nto Montreal",
        p1: "Chala Le Gouter Antillais was born from a deep love of Caribbean culture and the authentic flavors of the Antilles. Every dish we serve carries the spirit of the islands — vibrant, soulful, and made with pride.",
        p2: "Our story begins in family kitchens, where the aromas of marinated pork, jerk spices, and coconut rice filled the air. We carried those traditions across the ocean to share them with Montreal.",
        p3: "Today, we are proud to serve the Montreal community authentic Haitian and Antillean cuisine, prepared fresh daily using traditional family recipes and the finest ingredients we can find.",
      },
      values: {
        title: "What We Stand For",
        items: [
          { icon: "ChefHat", title: "Authentic Tradition", desc: "Every recipe is rooted in generations of Antillean culinary heritage." },
          { icon: "Leaf", title: "Fresh Quality", desc: "We never compromise on ingredient quality. Fresh, every single day." },
          { icon: "Heart", title: "Community Love", desc: "We are proud members of the Montreal community, giving back with every meal." },
          { icon: "Star", title: "Warm Hospitality", desc: "When you eat with us, you are family. That is the Caribbean way." },
        ],
      },
      mission: { title: "Our Mission", text: "To share the vibrant flavors and warm hospitality of the Caribbean with every person who walks through our doors — making every meal a celebration of culture, community, and authentic island cuisine." },
    },
    cateringPage: {
      hero: { overline: "Catering & Events", title: "Unforgettable Events\nStart With Great Food" },
      intro: { title: "Caribbean Catering\nfor Every Occasion", p1: "Whether you're planning a birthday party, corporate lunch, family reunion, or private celebration, Chala Le Gouter Antillais brings the warmth and bold flavors of the Caribbean directly to your event.", p2: "Our professional catering team handles everything — from menu planning to setup and service — so you can focus on enjoying your special day." },
      whyUs: { title: "Why Choose Our Catering?", items: ["Authentic Caribbean recipes", "Fresh, high-quality ingredients", "Flexible portion sizes", "On-site setup available", "Professional and friendly team", "Customizable menus to suit all tastes"] },
      contact: { title: "Ready to Book?", subtitle: "Contact us today for a free quote tailored to your event.", call: "Call Us Now", email: "Send Inquiry" },
    },
    reviewsPage: {
      hero: { overline: "Reviews", title: "Loved by Montreal" },
      overall: { rating: "4.9", count: "200+", label: "Reviews" },
      cta: { title: "Share Your Experience", subtitle: "Have you dined with us? We'd love to hear from you!", btn: "Leave a Review on Google" },
    },
  },
  fr: {
    nav: {
      home: "Accueil", menu: "Menu", about: "Notre Histoire",
      catering: "Traiteur", reviews: "Avis", contact: "Contact",
      orderOnline: "Commander",
    },
    hero: {
      badge: "Le Joyau Caribéen de Montréal",
      headline: "Saveurs Caribéennes\nAuthentiques à Montréal",
      subheadline: "Ingrédients frais, saveurs insulaires audacieuses, et des repas inoubliables préparés avec amour.",
      ctaOrder: "Commander en Ligne",
      ctaMenu: "Voir le Menu",
      ctaCall: "Appeler",
    },
    popularDishes: {
      overline: "Plats Signature",
      title: "Goûtez les Caraïbes\nà Chaque Bouchée",
      subtitle: "Préparés avec amour selon des recettes authentiques transmises de génération en génération.",
      viewMenu: "Voir le Menu Complet",
      dishes: [
        { name: "Griot", description: "Porc haïtien mariné et croustillant, mijoté aux agrumes et épices, frit à la perfection dorée.", tag: "Favori" },
        { name: "Jerk Chicken", description: "Poulet tendre avec marinade jamaïcaine audacieuse, grillé et servi avec des accompagnements caribéens.", tag: "Best-Seller" },
        { name: "Riz & Haricots", description: "Riz parfumé mijoté au lait de coco, haricots rouges et épices créoles authentiques.", tag: "" },
        { name: "Bananes Plantains", description: "Bananes plantains sucrées et caramélisées — l'accompagnement caribéen par excellence.", tag: "" },
        { name: "Patties", description: "Pâtisserie feuilletée et dorée, garnie de viande épicée à la façon caribéenne.", tag: "Street Food" },
        { name: "Combos Caribéens", description: "Généreuses portions de plusieurs plats signature en un repas complet et savoureux.", tag: "Excellent Rapport" },
      ],
    },
    whyUs: {
      overline: "Pourquoi Nous Choisir",
      title: "Plus Qu'un\nSimple Restaurant",
      subtitle: "Nous apportons la chaleur et l'âme des Caraïbes dans chaque assiette que nous servons.",
      features: [
        { icon: "ChefHat", title: "Recettes Authentiques", desc: "Des recettes antillaises et caribéennes traditionnelles transmises de génération en génération." },
        { icon: "Leaf", title: "Ingrédients Frais", desc: "Nous sélectionnons les ingrédients les plus frais pour offrir des saveurs maximales." },
        { icon: "Heart", title: "Fait avec Amour", desc: "Chaque repas est préparé avec soin, passion et l'esprit de l'hospitalité caribéenne." },
        { icon: "Users", title: "Apprécié des Montréalais", desc: "Un pilier incontournable de la scène culinaire caribéenne de Montréal, apprécié par des milliers." },
        { icon: "Utensils", title: "Famille & Traiteur", desc: "Idéal pour repas en famille, fêtes, traiteur en entreprise et tous vos événements spéciaux." },
      ],
    },
    about: {
      overline: "Notre Histoire",
      title: "Un Goût de Chez Nous,\nIci à Montréal",
      p1: "Chala Le Gouter Antillais est né d'un profond amour pour la culture caribéenne et les saveurs authentiques des Antilles. Notre cuisine raconte des histoires — de marchés aux épices, de cuisines familiales et de l'esprit vibrant des îles.",
      p2: "Nous apportons à Montréal les saveurs audacieuses et envoûtantes de la cuisine haïtienne et antillaise, en utilisant des recettes familiales traditionnelles et les ingrédients les plus frais. Chaque repas est une célébration de nos origines.",
      cta: "Lire Notre Histoire Complète",
      stats: [
        { value: "10+", label: "Ans au Service de Montréal" },
        { value: "500+", label: "Clients Heureux par Semaine" },
        { value: "100%", label: "Recettes Authentiques" },
      ],
    },
    reviews: {
      overline: "Avis Clients",
      title: "Ce que Dit\nMontréal",
      subtitle: "Rejoignez des milliers de clients satisfaits qui aiment notre cuisine caribéenne authentique.",
      testimonials: [
        { name: "Marie-Claire Fontaine", location: "Montréal-Nord", rating: 5, text: "Le meilleur griot que j'aie mangé en dehors d'Haïti! Les saveurs sont absolument authentiques et le service est toujours chaleureux. C'est mon endroit préféré pour la cuisine caribéenne à Montréal." },
        { name: "David Thompson", location: "Plateau-Mont-Royal", rating: 5, text: "Incroyable jerk chicken! J'ai essayé de nombreux restaurants caribéens à Montréal mais rien ne se compare à Chala. Le plateau combiné est d'une valeur exceptionnelle." },
        { name: "Isabelle Laurent", location: "Rivière-des-Prairies", rating: 5, text: "Nous avons commandé le service traiteur pour notre fête de bureau et tout le monde a été époustouflé. Service professionnel, portions généreuses et saveurs vraiment authentiques. 10/10!" },
        { name: "Jean-Paul Moreau", location: "Saint-Léonard", rating: 5, text: "Les plantains et le riz aux haricots sont extraordinaires! Un joyau caché à Montréal. Toute notre famille adore venir ici pour les repas du dimanche." },
        { name: "Sophie Beauchamp", location: "Laval", rating: 5, text: "Dès la première bouchée, je me suis retrouvée aux Caraïbes. La nourriture est fraîche, savoureuse et préparée avec amour. Je recommande vivement l'assiette combo!" },
        { name: "Antoine Delacroix", location: "Anjou", rating: 5, text: "Les meilleurs patties caribéens de la ville! Mes collègues et moi commandons ici chaque vendredi. Toujours frais, toujours délicieux, toujours à l'heure." },
      ],
    },
    catering: {
      overline: "Traiteur & Événements",
      title: "Nous Apportons les\nCaraïbes Chez Vous",
      subtitle: "Des rassemblements familiaux intimes aux grands événements d'entreprise, nous rendons chaque occasion inoubliable.",
      events: [
        { icon: "PartyPopper", title: "Anniversaires", desc: "Rendez votre célébration inoubliable avec un festin caribéen pour famille et amis." },
        { icon: "Building2", title: "Événements d'Entreprise", desc: "Impressionnez votre équipe et vos clients avec une expérience traiteur caribéenne unique." },
        { icon: "Heart", title: "Réunions Privées", desc: "Dîners intimes, anniversaires, diplômes — nous traitons chaque moment spécial." },
        { icon: "Users", title: "Réunions de Famille", desc: "Rassemblez la famille autour de nos généreux plateaux caribéens pour régaler tout le monde." },
      ],
      cta: "Demander un Devis",
      ctaSecondary: "Appeler pour Discuter",
      features: ["Menus personnalisables", "Sur place ou livraison", "Toute taille de groupe", "Service professionnel"],
    },
    contact: {
      overline: "Nous Trouver",
      title: "Venez Nous Rendre Visite",
      subtitle: "Nous serons ravis de vous accueillir. Venez vivre l'expérience caribéenne au cœur de Montréal.",
      address: "11866 Bd Rivière-des-Prairies\nMontréal, QC H1C 1P9",
      phone: "(514) 588-3708",
      hoursTitle: "Heures d'Ouverture",
      hours: [
        { day: "Lundi", hours: "11h00 – 19h00" },
        { day: "Mardi", hours: "11h00 – 20h00" },
        { day: "Mercredi", hours: "11h00 – 21h00" },
        { day: "Jeudi", hours: "11h00 – 21h00" },
        { day: "Vendredi", hours: "11h00 – 21h00" },
        { day: "Samedi", hours: "11h00 – 20h00" },
        { day: "Dimanche", hours: "12h00 – 19h00" },
      ],
      form: {
        title: "Envoyez-Nous un Message",
        name: "Nom Complet", email: "Adresse E-mail", phone: "Téléphone (Optionnel)",
        subject: "Sujet", message: "Votre Message", send: "Envoyer le Message",
        success: "Message envoyé! Nous vous répondrons bientôt.",
        error: "Échec de l'envoi. Veuillez nous appeler directement.",
      },
    },
    footer: {
      tagline: "Saveurs caribéennes authentiques au cœur de Montréal.",
      quickLinks: "Liens Rapides", contactUs: "Contact", hours: "Horaires",
      copyright: "© 2025 Chala Le Gouter Antillais. Tous droits réservés.",
    },
    menu: {
      title: "Notre Menu",
      subtitle: "Découvrez notre sélection complète de plats caribéens authentiques",
      allItems: "Tous les Plats",
      spicy: "Épicé",
    },
    aboutPage: {
      hero: { overline: "Notre Histoire", title: "Né d'un Amour pour la Culture Caribéenne" },
      story: {
        title: "Des Îles\nà Montréal",
        p1: "Chala Le Gouter Antillais est né d'un profond amour pour la culture caribéenne et les saveurs authentiques des Antilles. Chaque plat que nous servons porte l'esprit des îles — vibrant, envoûtant et préparé avec fierté.",
        p2: "Notre histoire commence dans des cuisines familiales, où les arômes du porc mariné, des épices jerk et du riz au coco remplissaient l'air. Nous avons porté ces traditions à travers l'océan pour les partager avec Montréal.",
        p3: "Aujourd'hui, nous sommes fiers de servir à la communauté montréalaise une cuisine haïtienne et antillaise authentique, préparée fraîchement chaque jour selon des recettes familiales traditionnelles.",
      },
      values: {
        title: "Nos Valeurs",
        items: [
          { icon: "ChefHat", title: "Tradition Authentique", desc: "Chaque recette est ancrée dans des générations de patrimoine culinaire antillais." },
          { icon: "Leaf", title: "Qualité Fraîche", desc: "Nous ne faisons jamais de compromis sur la qualité des ingrédients. Frais, chaque jour." },
          { icon: "Heart", title: "Amour Communautaire", desc: "Nous sommes fiers membres de la communauté montréalaise, donnant avec chaque repas." },
          { icon: "Star", title: "Hospitalité Chaleureuse", desc: "Quand vous mangez chez nous, vous êtes en famille. C'est la façon caribéenne." },
        ],
      },
      mission: { title: "Notre Mission", text: "Partager les saveurs vibrantes et l'hospitalité chaleureuse des Caraïbes avec chaque personne qui franchit nos portes — faisant de chaque repas une célébration de la culture, de la communauté et de la cuisine insulaire authentique." },
    },
    cateringPage: {
      hero: { overline: "Traiteur & Événements", title: "Des Événements\nInoubliables Commencent\npar une Grande Cuisine" },
      intro: { title: "Traiteur Caribéen\npour Chaque Occasion", p1: "Que vous planifiiez un anniversaire, un déjeuner d'entreprise, une réunion de famille ou une célébration privée, Chala Le Gouter Antillais apporte la chaleur et les saveurs audacieuses des Caraïbes directement à votre événement.", p2: "Notre équipe de traiteur professionnelle s'occupe de tout — de la planification du menu à la mise en place et au service — pour que vous puissiez vous concentrer sur la joie de votre journée spéciale." },
      whyUs: { title: "Pourquoi Choisir Notre Traiteur?", items: ["Recettes caribéennes authentiques", "Ingrédients frais de haute qualité", "Portions flexibles", "Installation sur site disponible", "Équipe professionnelle et amicale", "Menus personnalisables"] },
      contact: { title: "Prêt à Réserver?", subtitle: "Contactez-nous aujourd'hui pour un devis gratuit adapté à votre événement.", call: "Appelez-Nous", email: "Envoyer une Demande" },
    },
    reviewsPage: {
      hero: { overline: "Avis", title: "Aimé par Montréal" },
      overall: { rating: "4.9", count: "200+", label: "Avis" },
      cta: { title: "Partagez Votre Expérience", subtitle: "Vous avez dîné chez nous? Nous aimerions avoir votre avis!", btn: "Laisser un Avis sur Google" },
    },
  },
};

export default translations;
